import { formatNumber, numberFormatterLocal } from '@pp/core/src/utils/formatters';

export const hasDotOrComma = (value: string) => {
  return value.search(/[.,]/g) >= 0;
};

export const getDotOrCommaIndex = (value: string) => {
  return value.search(/[.,]/g);
};

export const truncateToTwoDecimal = (num: number) => {
  const strNum = num.toString();
  const decimalIndex = strNum.indexOf('.');
  if (decimalIndex !== -1) {
    return parseFloat(strNum.slice(0, decimalIndex + 3));
  }
  return num;
};

export const numberFormatter = (num: number, locale: string, trailingZeros: boolean = true) => {
  if (num % 1 === 0 && trailingZeros) {
    return formatNumber(locale, Number(num.toString().replace(/(\.0|\.00)$/, '')));
  } else {
    return new Intl.NumberFormat(numberFormatterLocal(locale), {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  }
};

export const trimmedTime = (inputTime: string): string => {
  if (!inputTime) return '';

  const timeParts = inputTime.split(':');
  const hours = timeParts[0];
  const minutes = timeParts[1];
  const trimmedTime = `${hours}:${minutes}`;

  return trimmedTime;
};

export const getDateTime = (datetimeStr: string, format: string = 'full'): Date | string | null => {
  try {
    // Assuming the format is YYYY-MM-DDTHH:MM:SS
    const dateTimeParts: number[] = datetimeStr.split(/[T\-\s:]/).map((part) => parseInt(part));
    if (dateTimeParts.length === 6) {
      const [year, month, day, hour, minute, second] = dateTimeParts;
      const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
      const formattedTime = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')} GMT`;

      const months = [
        'JANUARY_ABBREVIATED',
        'FEBRUARY_ABBREVIATED',
        'MARCH_ABBREVIATED',
        'APRIL_ABBREVIATED',
        'MAY_ABBREVIATED',
        'JUNE_ABBREVIATED',
        'JULY_ABBREVIATED',
        'AUGUST_ABBREVIATED',
        'SEPTEMBER_ABBREVIATED',
        'OCTOBER_ABBREVIATED',
        'NOVEMBER_ABBREVIATED',
        'DECEMBER_ABBREVIATED',
      ];

      switch (format) {
        case 'date':
          return formattedDate;
        case 'time':
          return formattedTime;
        case 'day':
          return day.toString().padStart(2, '0');
        case 'month':
          return months[month - 1];
        default:
          return `${formattedDate} ${formattedTime}`;
      }
    } else {
      throw new Error('Incorrect format. Please provide the datetime string in the format YYYY-MM-DDTHH:MM:SS');
    }
  } catch (error: any) {
    console.error(error.message);
    return null;
  }
};

interface IException {
  [key: string]: { original: string; replacement: string };
}
export const EXCEPTIONS: IException = {
  COP: { original: '$', replacement: 'COP' },
  VES: { original: 'VES', replacement: 'Bs' },
  TWD: { original: '$', replacement: 'NT$' },
  TTD: { original: '$', replacement: 'TT$' },
  BTC6: { original: 'BTC6', replacement: 'μBTC' },
  BTC3: { original: 'BTC3', replacement: 'mBTC' },
  XAF: { original: 'FCFA', replacement: 'XAF' },
  GHS: { original: 'GH₵', replacement: 'GH¢' },
  RSD: { original: 'RSD', replacement: 'Дин.' },
  UZS: { original: 'UZS', replacement: 'лв' },
  KRW2: { original: 'KRW2', replacement: '₩' },
  INR1: { original: 'INR1', replacement: '₹' },
  KES: { original: 'KES', replacement: 'Ksh' },
  IDR1: { original: 'IDR1', replacement: 'Rp' },
  IDR2: { original: 'IDR2', replacement: 'Rp' },
  PEN: { original: 'PEN', replacement: 'S/.' },
  USDT: { original: 'USDT', replacement: '$' },
  ZMW: { original: 'ZK', replacement: 'ZMW' },
  BGN: { original: 'BGN', replacement: 'лв' },
  ETH: { original: 'ETH', replacement: 'Ξ' },
  ETH4: { original: 'ETH4', replacement: 'Ξ' },
  ETH7: { original: 'ETH7', replacement: 'Ξ' },
  ETH9: { original: 'ETH9', replacement: 'Ξ' },
  KZT: { original: '₸', replacement: 'лв' },
  VND2: { original: 'VND2', replacement: '₫' },
};
